import { render } from "./IconElectraClass.vue?vue&type=template&id=34a0e4e5"
import script from "./IconElectraClass.vue?vue&type=script&lang=js"
export * from "./IconElectraClass.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__